/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MissionStartingState {
    Waiting = '0',
    Instructed = 1,
}
